module.exports = __webpack_public_path__ + "img/cy.ba677611.svg";